/* =====================================================================
   ZGD — "Complétalo": agrega el complemento al carrito junto al producto.

   Cómo funciona: se engancha al submit del formulario de producto. Si la
   casilla está marcada, primero mete el complemento con /cart/add.js y
   después deja que el tema haga lo suyo con el producto principal.

   Por qué en ese orden: si el complemento falla (se agotó entre que cargó
   la página y el clic), el producto principal entra igual. Nunca se pierde
   la venta por culpa del complemento.

   Y el botón muestra el total de los dos, para que nadie se lleve una
   sorpresa al llegar al carrito.
   ===================================================================== */
(function () {
  'use strict';

  function money(centavos) {
    // La tienda usa punto para los miles y no usa decimales.
    return '$' + Math.round(centavos / 100).toLocaleString('es-CO');
  }

  function init(caja) {
    if (caja.dataset.zgdListo) return;
    caja.dataset.zgdListo = '1';

    var chk = caja.querySelector('.zgd-comp__input');
    var idForm = caja.dataset.form;
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!chk || !form) return;

    var boton = form.querySelector('.product-form__submit');
    var etiqueta = boton ? boton.querySelector('span') : null;
    var textoOriginal = etiqueta ? etiqueta.textContent.trim() : '';

    /* ---- el total en el botón ---- */
    function pintarTotal() {
      if (!etiqueta || !textoOriginal) return;
      if (boton.disabled) return;
      if (chk.checked) {
        var base = parseInt(caja.dataset.precioBase, 10) || 0;
        var extra = parseInt(caja.dataset.precio, 10) || 0;
        etiqueta.textContent = textoOriginal + ' · ' + money(base + extra);
      } else {
        etiqueta.textContent = textoOriginal;
      }
    }
    chk.addEventListener('change', pintarTotal);

    /* Si el cliente cambia de color/variante, el precio base cambia: el tema
       re-renderiza el bloque de precio, así que lo volvemos a leer. */
    document.addEventListener('variant:change', pintarTotal);

    /* ---- agregar los dos al carrito ---- */
    var enCurso = false;
    form.addEventListener(
      'submit',
      function (e) {
        if (!chk.checked || enCurso) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        enCurso = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(caja.dataset.variante, 10), quantity: 1 }] })
        })
          .catch(function () {
            /* Si el complemento falla, seguimos igual con el producto
               principal. La venta importante no se toca. */
          })
          .then(function () {
            chk.checked = false;
            pintarTotal();
            form.requestSubmit ? form.requestSubmit(boton) : form.submit();
            setTimeout(function () {
              enCurso = false;
            }, 1200);
          });
      },
      true
    );
  }

  function arrancar() {
    document.querySelectorAll('[data-zgd-completalo]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
